// extracted by mini-css-extract-plugin
export default {"Container":"Home_Container__yaRGd","Intro":"Home_Intro__qu-PS","Title":"Home_Title__k0yUY","Description":"Home_Description__J9hOc","BtnGroup":"Home_BtnGroup__D7bjE"};